export const PACKAGE = process.env.NEXT_PUBLIC_PACKAGE || "";
export const PACKAGE_VERSION = process.env.NEXT_PUBLIC_PACKAGE_VERSION || "";
export const RELEASE = process.env.NEXT_PUBLIC_RELEASE || "";
export const ROLLBAR_TOKEN = process.env.NEXT_PUBLIC_ROLLBAR_TOKEN || "";
export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN || "";
export const ENV_NAME = process.env.NEXT_PUBLIC_ENV_NAME || "";
